import { defineComponent } from 'vue';
import Picker from './components/Picker';
import Presets from './components/Presets';
export default defineComponent({
    name: 'AColorPickerPanel',
    props: {
        prefixCls: { type: String, required: true },
        value: { type: Object, required: true },
        format: { type: String, default: 'hex' },
        disabledAlpha: Boolean,
        allowClear: Boolean,
        disabledFormat: Boolean,
        presets: { type: Array },
        disabled: Boolean,
    },
    emits: ['change', 'changeComplete', 'formatChange', 'clear'],
    setup(props, { emit }) {
        return () => {
            const pre = props.prefixCls;
            return (<div class={`${pre}-panel`}>
          <Picker prefixCls={pre} value={props.value} format={props.format} disabledAlpha={props.disabledAlpha} allowClear={props.allowClear} disabledFormat={props.disabledFormat} disabled={props.disabled} onChange={c => emit('change', c)} onChangeComplete={c => emit('changeComplete', c)} onFormatChange={f => emit('formatChange', f)} onClear={() => emit('clear')}/>
          <Presets prefixCls={pre} presets={props.presets} disabled={props.disabled} onChange={c => emit('change', c)} onChangeComplete={c => emit('changeComplete', c)}/>
        </div>);
        };
    },
});
export { Picker, Presets };
